import { createContext } from "react";

const EventCommonFilter = createContext({});

export default EventCommonFilter;
